<template>
    <div class="container">
        <div class="header">
            <div class="banner">
                <div class="title_banner">
                    <img :src="titleBannerImage">
                </div>
            </div>
        </div>
        <div class="context">
            <!-- 大会介绍 -->
            <div class="introduce mt--83">
                <!-- 功能标题 -->
                <div class="feature_title mb-15">参选企业</div>
                <div class="long_line"></div>

                <FirmList></FirmList>
            </div>

        </div>
    </div>
</template>
<script>
import FirmList from "./components/FirmList"
import titleBannerImage from "@/assets/img/jinju-2024/title_banner@2x.png";
export default {
    mounted() {
        try {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0; // 兼容低版本ie
        } catch(err) {
            console.error(err);
        }

    },
    components: {
        FirmList,
    },

    data() {
        return {
            titleBannerImage,

        }
    }
}


</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: fit-content;
    background-color: #13349C;

    .header {
        .banner {
            height: 910px;
            width: 100%;
            background-image: url(~@/assets/img/jinju-2024/banner@2x.png);
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;

            .title_banner {
                height: fit-content;
                width: fit-content;
                padding-top: 83px;
                margin-left: auto;
                margin-right: auto;

                img {
                    width: 832px;
                    height: 368px;
                    margin: 0 auto 0;
                }
            }

        }
    }

    .context {
        width: 100%;
        height: 100%;
        padding-bottom: 195px;

        .bottom_line {
            position: relative;

            &::after {
                content: "";
                width: 100%;
                height: 2px;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -16px;
                background: #3DD0F5;
            }
        }

        .bottom_left_line {
            width: 80px;
            height: 2px;
            background: #3DD0F5;
        }

        .introduce {
            width: 1200px;
            background: #2658C8;
            opacity: 0.94;
            margin-left: auto;
            margin-right: auto;
            padding: 55px 100px;

            .introduce-image {
                width: 376px;
                height: 62px;
                margin-left: auto;
                margin-right: auto;
            }

            .setting-image {
                width: 925px;
                height: 551px;
                margin-left: auto;
                margin-right: auto;
            }

            .select_image {
                height: 24px;
                width: 677px;
                margin-left: auto;
                margin-right: auto;
            }

            .feature_title {
                font-family: FZDeSaiHeiS;
                font-weight: 550;
                font-size: 25px;
                color: #3DD0F5;
                line-height: 22px;
                text-align: center;
            }

            .left_title {
                color: #3dd0f5;
                font-size: 20px;
                line-height: 28px;
                font-family: Source Han Sans CN;
                font-weight: bold;
            }

            .text {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 28px;
            }

            .left-image {
                width: 45px;
                height: 41px;
            }

            .long_line {
                width: 100%;
                height: 1px;
                background: #3DD0F5;
            }

            .left_small_title {
                font-family: Hiragino Sans GB;
                font-weight: normal;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 24px;
                position: relative;
                margin-left: 15px;

                &::before {
                    content: "";
                    position: absolute;
                    left: -16px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 4px;
                    height: 14px;
                    background: #3DD0F5;
                    margin-top: 1px;
                }
            }

            .flow_tip {
                display: flex;

                .text_before {
                    font-weight: 100;
                    font-size: 18px;
                    color: #3DD0F5;
                    line-height: 22px;
                    margin-right: 20px;
                    font-family: Public Sans;

                    position: relative;

                    &::after {
                        content: "";
                        top: 50%;
                        right: -10px;
                        width: 1px;
                        height: 100%;
                        background: #3DD0F5;
                        position: absolute;
                        transform: translateY(-50%);

                    }
                }

                .text_after {
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 18px;
                    color: #3DD0F5;
                    line-height: 22px;
                }
            }

            .big_title {
                font-family: FZDeSaiHeiS;
                font-weight: normal;
                font-size: 30px;
                color: #3DD0F5;
                line-height: 22px;
                text-align: center;
            }

        }
    }

    .buttonWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 13px;

        .button {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            padding: 13px 49px;
            background: #13349C;

        }
    }



    .mb-0 {
        margin-bottom: 0 !important;
    }

    .mb-10 {
        margin-bottom: 10px;
    }

    .mb-13 {
        margin-bottom: 13px;
    }

    .mb-15 {
        margin-bottom: 15px;
    }

    .mb-20 {
        margin-bottom: 20px;
    }

    .mb-27 {
        margin-bottom: 27px;
    }

    .mb-29 {
        margin-bottom: 29px;
    }

    .mb-30 {
        margin-bottom: 30px;
    }

    .mb-33 {
        margin-bottom: 33px;
    }

    .mb-34 {
        margin-bottom: 34px;
    }

    .mb-40 {
        margin-bottom: 40px;
    }

    .mb-41 {
        margin-bottom: 41px;
    }

    .mb-45 {
        margin-bottom: 45px;
    }

    .mb-47 {
        margin-bottom: 47px
    }

    .mb-52 {
        margin-bottom: 52px;
    }

    .mb-57 {
        margin-bottom: 57px;
    }

    .mb-60 {
        margin-bottom: 60px;
    }

    .mb-66 {
        margin-bottom: 66px;
    }

    .mb-70 {
        margin-bottom: 70px;
    }

    .mb-71 {
        margin-bottom: 71px;
    }

    .mb-92 {
        margin-bottom: 92px;
    }

    .mb-95 {
        margin-bottom: 95px;
    }

    .mb-96 {
        margin-bottom: 96px;
    }

    .mb-100 {
        margin-bottom: 100px !important;
    }

    .mb-111 {
        margin-bottom: 111px;
    }

    .mt--83 {
        margin-top: -83px !important;
    }

    .mt-30 {
        margin-top: 30px;
    }

    .mt-41 {
        margin-top: 41px;
    }

    .mr-36 {
        margin-right: 36px;
    }
}
</style>